'use strict';

const lpmsHelper = require('../helpers/lpmHelper');
const braintreeGeneral = require('../../braintreeGeneral');
const lpmPaymentProcessing = require('../components/lpmPaymentProcessing');

/**
 * A class represented a Local payment method builder
 */
class LpmsBuilder {
    constructor() {
        this.configs = lpmsHelper.getBraintreeLpmConfigs();
        this.buttonsEls = document.querySelectorAll('.js-braintree-lpm-button');
        this.clientInstancePromise = braintreeGeneral.createClientInstance(this.configs.clientToken);
    }

    /**
     * Initiates general LPM's logic
     */
    async init() {
        await this.loadPayPalSdk();

        Array.from(this.buttonsEls).forEach(btn => {
            const fundingSource = btn.getAttribute('data-funding-source');
            const buttonConfiguration = this.createButtonConfigurations(fundingSource);

            this.render(buttonConfiguration, `.js-braintree-${fundingSource}-button`);
        });
    }

    /**
     * Creates the button configuration will be passed to the Paypal SDK
     * @param {string} fundingSource A Local payment method's funding source
     * @returns {Object} An object with the LPM's button configuration
     */
    createButtonConfigurations(fundingSource) {
        const that = this;

        return {
            onInit: (_, actions) => {
                return actions.disable();
            },
            onClick: async() => {
                const isNonInstantsLpm = that.configs.nonInstantLpmsList.includes(fundingSource);

                if (isNonInstantsLpm) {
                    const continueButton = document.querySelector('button.submit-payment');

                    continueButton?.click();
                } else {
                    const braintreeLpmModel = require('../braintreesdk/braintreeLpmModel');

                    await braintreeLpmModel.initLpm(that.clientInstancePromise);

                    lpmPaymentProcessing.onLpmButtonClick(fundingSource, that.configs);
                }
            },
            fundingSource: fundingSource
        };
    }

    /**
     * Renders the LPM's tab, mark and button
     * @param {Object} buttonConfiguration An object with the LPM's button configuration
     * @param {string} buttonSelector The selector where the LPM button will be rendered
     */
    render(buttonConfiguration, buttonSelector) {
        const btnInitResult = window.lpmPaypal.Buttons(buttonConfiguration);
        const isOxxo = buttonConfiguration.fundingSource === window.braintreeConstants.PAYMENT_METHOD_IDS_NON_INSTANT_LPM.OXXO;

        if (btnInitResult.isEligible() && !isOxxo) {
            this.renderButtonMark(buttonConfiguration.fundingSource);
            this.showButtonTab(buttonConfiguration.fundingSource);

            btnInitResult.render(buttonSelector);
        // Shows the Oxxo tab
        } else if (isOxxo) {
            this.showButtonTab(buttonConfiguration.fundingSource);
        }
    }

    /**
     * Renders LPM's mark
     * @param {string} fundingSource A Local payment method's funding source
     */
    renderButtonMark(fundingSource) {
        window.lpmPaypal.Marks({
            fundingSource: fundingSource
        }).render(`.js-${fundingSource}-mark`);
    }

    /**
     * Renders LPM's tab
     * @param {string} fundingSource A Local payment method's funding source
     */
    showButtonTab(fundingSource) {
        const lpmTabEl = document.querySelector(`.js-nav-item-${fundingSource}`);

        if (lpmTabEl) {
            lpmTabEl.classList.remove('d-none');
        }
    }

    /**
     * Loads PayPal sdk
     * @returns {Promise} new Promise resolve/reject
     */
    async loadPayPalSdk() {
        return this.clientInstancePromise
            .then(clientInstance => {
                return braintree.paypalCheckout.create({
                    client: clientInstance
                });
            })
            .then((paypalCheckoutInstance => {
                return paypalCheckoutInstance.loadPayPalSDK(this.configs.paypalSdkConfigs);
            }))
            .then(() => Promise.resolve({}))
            .catch(error => Promise.reject(error));
    }
}

module.exports = LpmsBuilder;
